module.exports = __webpack_public_path__ + "assets/img/al1.c630eb21.jpg";